import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Building2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";
import { setActiveCompany } from "@/lib/activeCompany";

const FIELDS = [["name", "Raison sociale", "text"], ["siren", "SIREN (9 chiffres)", "text"], ["sector", "Secteur d'activité", "text"],
  ["headcount", "Effectif", "number"], ["revenue", "Chiffre d'affaires annuel (€)", "number"], ["address", "Adresse (facultatif)", "text"]];

export const CreateCompany = () => {
  const { reload, user } = useAuth();
  const navigate = useNavigate();
  const [v, setV] = useState({ name: "", siren: "", sector: "", headcount: "", revenue: "", address: "" });
  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/business/companies", { ...v, headcount: Number(v.headcount), revenue: Number(v.revenue), address: v.address || null });
      await reload();
      setActiveCompany(data.id);
      navigate("/entreprise", { replace: true });
    } catch (err) { toast.error(formatApiError(err)); }
  };
  return (
    <section className="card-surface mx-auto max-w-xl space-y-5 p-6" data-testid="create-company">
      <div className="flex items-center gap-3"><span className="tone-chip tone-butter flex h-10 w-10 items-center justify-center rounded-xl"><Building2 className="h-5 w-5" /></span>
        <div><h1 className="text-2xl font-extrabold">{user.companies?.length ? "Ajouter une entreprise" : "Créer l'espace CASHMY Entreprise"}</h1><p className="text-sm text-muted-foreground">Vous en serez le dirigeant et pourrez inviter un comptable ou des lecteurs.</p></div></div>
      {user.read_only ? <p className="text-sm text-muted-foreground">Compte en lecture seule.</p> : (
        <form onSubmit={submit} className="space-y-3">
          {FIELDS.map(([k, l, type]) => (
            <div key={k}><Label htmlFor={`co-${k}`}>{l}</Label>
              <Input id={`co-${k}`} type={type} min={type === "number" ? 0 : undefined} value={v[k]} onChange={(e) => setV({ ...v, [k]: e.target.value })} required={k !== "address"}
                pattern={k === "siren" ? "\\d{3} ?\\d{3} ?\\d{3}" : undefined} className="mt-1" data-testid={`company-input-${k}`} /></div>
          ))}
          <Button type="submit" className="w-full rounded-full" data-testid="company-create-submit">Créer l'espace entreprise</Button>
        </form>
      )}
    </section>
  );
};
